import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import closeIcon from "../assets/close-icon.png";
import { useLanguage, getStripePaymentModalTranslation } from '../hooks/useLanguage';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const STRIPE_PUBLISHABLE_KEY = "pk_test_51RieuARQxn3ox4M61qxnCzHcmlvCbyxKlL0SYHYCm2VLduSwcLOVln7xIRF5ilWljtq0uZNqErWyeW2Mv9uyPGAk00kmSNGgE5";

const StripePaymentModal = ({ isOpen, onClose }) => {
  const [isSpanish] = useLanguage();
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [error, setError] = useState(null);
  const PRODUCTS = useSelector(state => state.products);

  if (!isOpen) return null;

  // Function to get current user ID - replace with your actual user retrieval logic
  const getCurrentUserId = () => {
    // Option 1: From localStorage
    const userId = sessionStorage.getItem('user_id')
    if (userId) return userId;   
    
    // Option 2: From cookies
    const userIdFromCookie = Cookies.get('userId');
    if (userIdFromCookie) return userIdFromCookie;
    
    // Option 3: From a user context/state management const { user } = useContext(UserContext); return user?.id;
    
    // Fallback - you should replace this with actual user ID
    console.warn('No user ID found, using fallback');
    return null;
  };

  const handleBuy = async (product, idx) => {
    setLoadingIndex(idx);
    setError(null);
    
    try {
      const currentUserId = getCurrentUserId();
      
      if (!currentUserId) {
        throw new Error('User not logged in. Please log in to continue.');
      }

      // Parse price to cents (e.g., "€499.00" -> 49900)
      const amount = Math.round(
        parseFloat(product.price.replace(/[^\d.]/g, "")) * 100
      );

      const requestBody = {
        amount,
        currency: 'eur',
        productName: `${product.credits} credits`,
        productDescription: product.price,
        user_id: currentUserId, // Send user_id in the main body
        metadata: { 
          productId: product.productId,
          // userId will be merged from user_id in the backend
        },
        successUrl: `${window.location.origin}/success?session_id={CHECKOUT_SESSION_ID}`,
        cancelUrl: window.location.origin + '/cancel',
      };

      // Call your backend to create a Stripe Checkout Session
      const response = await fetch(`${API_BASE_URL}/api/payments/session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });
      
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Failed to create session');

      // Store sessionId for use on the success page
      localStorage.setItem('stripeSessionId', data.id);

      // Redirect to Stripe Checkout
      window.location.href = data.url;
    } catch (err) {
      console.error('Payment error:', err);
      setError(err.message);
    } finally {
      setLoadingIndex(null);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-999">
      <div className="bg-white p-8 pb-0 rounded shadow-lg max-w-2xl w-full">
        <div className='flex justify-between items-center mb-6'>
          <h2 className='text-2xl font-bold'>{getStripePaymentModalTranslation('purchaseCredits', isSpanish)}</h2>
          <img className='h-6 w-6 cursor-pointer' src={closeIcon} onClick={onClose} alt="Close" />
        </div>
        {error && <div className="text-red-600 mb-2">{error}</div>}
        <table className="w-full mb-4 border-separate" style={{ borderSpacing: 0 }}>
          <tbody>
            {PRODUCTS.map((product, idx) => {
              const isFeatured = idx === 0;
              const isLast = idx === PRODUCTS.length - 1;
              return (
                <tr
                  key={product.credits}
                  className={
                    isFeatured
                      ? "text-white option-1"
                      : "bg-white text-black"
                  }
                >
                  <td
                    className={`${isFeatured && "first-td bg-primary text-white"} py-6 pl-8 text-left text-lg font-medium`}
                  >
                    {product.credits} {getStripePaymentModalTranslation('credits', isSpanish)}
                  </td>
                  <td
                    className={`py-6 text-2xl font-bold text-left ${isFeatured ? 'text-white bg-primary' : 'text-black'}`}
                  >
                    {product.price}
                  </td>
                  <td className={`py-6 pr-8 flex justify-end last-td ${isFeatured ? 'bg-primary' : 'bg-white'}`}>
                    <button
                      className={
                        isFeatured
                          ? "bg-white font-semibold py-3 px-12 rounded-full text-lg"
                          : "bg-secondary font-semibold py-3 px-12 rounded-full text-lg"
                      }
                      onClick={() => handleBuy(product, idx)}
                      disabled={loadingIndex !== null}
                      style={{
                        borderRadius: '9999px',
                        minWidth: '160px',
                      }}
                    >
                      <span className={`flex justify-center items-center text-base ${isFeatured && 'shine'}`}>
                      {loadingIndex === idx ? getStripePaymentModalTranslation('processing', isSpanish) : getStripePaymentModalTranslation('buy', isSpanish)}
                      </span>
                    </button>
                  </td>
                </tr>
              );
            })}
            {/* Divider lines between rows except after the last one */}
            
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StripePaymentModal;